import React, { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { STATE_AND_CITIES } from "../../../utils/StateAndCities";
import { Select } from "antd";
import { If } from "react-condition";
import { ReactLoading } from "../../Dashboard/TinManagement/import";
import useAxios from "../../../hooks/useAxios";

const { Option } = Select;

const AGENT_APPLICATION_ID = "61d41ac7cc03506243d626f9";
const LATERAL_FORM_IDS = [
  "633190214529e62d9edc2fff",
  "62e91154309f9f7d5806d044",
];

function DeptDesg({
  onBlurHandler,
  data,
  defaultValue,
  isChild,
  approve,
  ocrDisabled,
  errorInputs,
  departments,
  tokenType,
  formId,
}) {

  const api = useAxios();
  const [loading, setLoading] = useState(false);
  const [element, setElement] = useState({
    id: uuidv4(),
    type: "departmentdesignation",
    properties: {
      placeholder: "Enter here...",
      required: true,
    },
    value: {},
  });

  const [allDesignations, setAllDesignations] = useState([]);
  const [department, setDepartment] = useState("");
  const [designation, setDesignation] = useState("");
  const [flag, setFlag] = useState(false);

  useEffect(() => {
    const obj = { ...data };
    setElement((prevElement) => ({
      ...prevElement,
      ...obj,
      value: {
        department: data?.value?.department || "",
        departmentText: data?.value?.departmentText || "",
        designation: data?.value?.designation || "",
        designationText: data?.value?.designationText || "",
      },
    }));
    setFlag(!flag);
  }, [data]);

  useEffect(() => {
    const init = async () => {
      let departmentText = "";
      let department = "";

      if (formId === AGENT_APPLICATION_ID && (!data?.value || (!data?.value?.department && !data?.value?.departmentText))) {
        const filterDept = departments.find(
          (ele) => ele?.department?.toLowerCase() === "operations",
        );

        departmentText = filterDept?.department;
        department = filterDept?._id;
        setDepartment(department);

        setElement((prevElement) => ({
          ...prevElement,
          value: {
            department: department || "",
            departmentText: departmentText || "",
          },
        }));
      } else {
        const rawDept = data?.value?.department || "";
        const rawDeptText = data?.value?.departmentText || "";
        const filterDept = departments?.find(
          (ele) =>
            ele?._id === rawDept ||
            ele?.department?.toLowerCase() === rawDeptText?.toLowerCase() ||
            ele?.department?.toLowerCase() === rawDept?.toLowerCase()
        );
        const resolvedDept = filterDept?._id || rawDept || "";
        setDepartment(resolvedDept);
      }
    };

    init();
  }, [flag, data, departments]);

  useEffect(() => {
    const init = async () => {
      if (department) {
        const allDesignations = await getDesignations(department);
        if (formId === AGENT_APPLICATION_ID && (!data?.value || (!data?.value?.designation && !data?.value?.designationText))) {
          let designationText = "";
          let designation = "";
          const filterDes = allDesignations.find(
            (ele) =>
              ele?.designation?.toLowerCase() === "cse" ||
              ele?.designation?.toLowerCase() === "customer support associate"
          );
          designationText = filterDes?.designation;
          designation = filterDes?._id;
          setDesignation(designation);
          setElement((prevElement) => ({
            ...prevElement,
            value: {
              ...prevElement?.value,
              designation: designation || "",
              designationText: designationText || "",
            },
          }));
        } else if (allDesignations && allDesignations.length > 0) {
          const rawDesg = data?.value?.designation || "";
          const rawDesgText = data?.value?.designationText || "";
          const filterDes = allDesignations.find(
            (ele) =>
              ele?._id === rawDesg ||
              ele?.designation?.toLowerCase() === rawDesgText?.toLowerCase() ||
              ele?.designation?.toLowerCase() === rawDesg?.toLowerCase()
          );
          if (filterDes) {
            setDesignation(filterDes._id);
          } else {
            setDesignation(rawDesg);
          }
        }
      }
    };
    init();
  }, [data, department]);

  const getDesignations = async (department) => {
    try {
      setLoading(true);
      const isLateralForm = LATERAL_FORM_IDS.includes(formId);
      const endpoint = isLateralForm
        ? `/departmentBasedDesignation/filteredDepartmentId/${department}`
        : `/departmentBasedDesignation/departmentId/${department}`;

      const { data } = await api.get(
        endpoint,
        {
          tokenType: tokenType === "user.token" ? "user" : "candidate",
        },
      );

      const { data: allDepartments } = data || {};
      const active = allDepartments?.filter((e) => e.status);
      setAllDesignations(active);
      return active;
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const onChangeHandlerDepartment = (value) => {
    const filter = departments?.find((e) => e?._id === value);
    setDepartment(value);
    setElement((prevElement) => ({
      ...prevElement,
      value: {
        ...prevElement.value,
        departmentText: filter?.department,
        department: value,
        designation: "",
        designationId: "",
      },
    }));
    setDesignation("");
  };

  const onChangeHandlerDesignation = (value) => {
    const filter = allDesignations?.find((e) => e?._id === value);
    setDesignation(value);
    setElement((prevElement) => ({
      ...prevElement,
      value: {
        ...prevElement.value,
        designation: value,
        designationText: filter?.designation,
      },
    }));
  };

  const foundErrorDepartment = errorInputs?.find(
    (ele) => ele?.label === "Select Department",
  );
  const foundErrorDesignation = errorInputs?.find(
    (ele) => ele?.label === "Select Designation",
  );

  return (
    <>
      {loading && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      <div
        className="form-group col-md-12 form-builder-element mb-3 form-view"
        data={JSON.stringify(element)}
      >
        <div className="">
          <label htmlFor="state">
            Select Department
            <If test={element?.properties?.required === true}>
              <span style={{ color: "red" }}>*</span>
            </If>
          </label>
          <Select
            key={department}
            id="department"
            showSearch
            className={`${foundErrorDepartment ? "border border-danger" : ""}`}
            disabled={
              approve || !element.editable || formId === AGENT_APPLICATION_ID
            }
            style={{ width: "100%", height: "37px" }}
            placeholder="Select Department"
            optionFilterProp="children"
            value={department}
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
            onChange={onChangeHandlerDepartment}
          >
            {departments?.map((department) => {
              return (
                <Select.Option value={department?._id}>
                  {department?.department || department?.departmentName}
                </Select.Option>
              );
            })}
          </Select>
          {foundErrorDepartment && (
            <span className="text-danger">{foundErrorDepartment?.value}</span>
          )}
        </div>
        {department && (
          <div className="mt-3">
            <label htmlFor="city">
              Select Designation
              <span style={{ color: "red" }}>*</span>
            </label>
            <Select
              key={designation}
              id="designation"
              disabled={approve || !element.editable || formId === AGENT_APPLICATION_ID}
              value={designation}
              showSearch
              className={`${
                foundErrorDesignation ? "border border-danger" : ""
              }`}
              style={{ width: "100%", height: "37px" }}
              placeholder="Select Designation"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
              onChange={onChangeHandlerDesignation}
            >
              {allDesignations?.map((designation) => {
                return (
                  <Select.Option value={designation?._id}>
                    {designation?.designation}
                  </Select.Option>
                );
              })}
            </Select>
            {foundErrorDesignation && (
              <span className="text-danger">
                {foundErrorDesignation?.value}
              </span>
            )}
          </div>
        )}
      </div>
    </>
  );
}

export default DeptDesg;
